// extracted by mini-css-extract-plugin
module.exports = {"pointsBlockWrapper":"CartMiniPointsBlock_pointsBlockWrapper___NAcf","dark":"CartMiniPointsBlock_dark__8erya"};